export default class DtoPumpingEquipments {
    constructor(obj) {
        this.idStation = obj.idStation

        this.turbidimeter = obj.turbidimeter
        this.chlorineResidualAnalyzer = obj.chlorineResidualAnalyzer
        this.flowMeasure = obj.flowMeasure
    }
}